export interface RankCtrValueGq {
  rank: number;
  ctr: number;
}

export const RankCtrValueGqProps = `
  rank
  ctr
`;
